import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import SwiperCore from 'swiper';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import RuleItem from './RuleItem';
import { useBreakpoints } from '../../../Components/Hooks/BreakpointHooks';

const TransactionalIncentive = ({ t, transactionals }) => {
  SwiperCore.use([FreeMode, Navigation, Thumbs]);
  const [thumbsSwiper] = useState(null);

  const events = [
    { name: 'Crédito recebido', rules: [] },
    { name: 'Expira em 30 dias', options: { days: 30 }, rules: [] },
    { name: 'Expira em 15 dias', options: { days: 15 }, rules: [] },
    { name: 'Expira em 7 dias', options: { days: 7 }, rules: [] },
    { name: 'Expira em 1 dia', options: { days: 1 }, rules: [] },
  ];

  const [incentiveTransactionals, setIncentiveTransactionals] =
    useState(events);
  const { isLg } = useBreakpoints();

  useEffect(() => {
    setIncentiveTransactionals(
      events.map((event) => {
        const transactionalsEvent = transactionals.filter((tr) =>
          tr.options?.days
            ? tr.event_name.includes(event.name) &&
              tr.options.days === event.options.days
            : tr.event_name.includes(event.name)
        );

        return { ...event, name: event.name, rules: transactionalsEvent };
      })
    );
  }, [transactionals]);

  return (
    <React.Fragment>
      <Row className="mt-4">
        <Col lg={12}>
          <div>
            <div className="horizontal-timeline my-3">
              <Swiper
                className="timelineSlider"
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                slidesPerView={isLg ? 4 : 'auto'}
              >
                <div className="swiper-wrapper">
                  {incentiveTransactionals.map((item, key) => (
                    <SwiperSlide key={key}>
                      <RuleItem
                        rules={item.rules}
                        active={item.active}
                        event={item.name}
                        transactionalType="incentive"
                      />
                    </SwiperSlide>
                  ))}
                </div>
              </Swiper>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default withTranslation()(TransactionalIncentive);
